// extracted by mini-css-extract-plugin
export default {"container":"BackNavigationLayout_container__XC72e","backPositioner":"BackNavigationLayout_backPositioner__jo1qF","back":"BackNavigationLayout_back__7THfJ"};